import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
import { Module } from "vuex/types";
import { ApiEditorState } from "./types";
import { RootState } from "@/store/types";

const apieditor: Module<ApiEditorState, RootState> = {
  // namespaced: true,
  actions,
  getters,
  mutations,
  state,
};

export default apieditor;
